'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_forms_FormLabel_FormLabel = require('../FormLabel/FormLabel.cjs.js');
const components_forms_BooleanInput_BooleanInput = require('./BooleanInput.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const labeledBooleanInputRoot = "_labeled-boolean-input-root_rt5rq_1";
const styles = {
	labeledBooleanInputRoot: labeledBooleanInputRoot
};

const LabeledBooleanInput = ({ children, type, value = void 0, "aria-label": ariaLabel = void 0, id = void 0, isDisabled = void 0, isErrored = void 0, isRequired = void 0, name = void 0, checked = false, onChange = () => {
}, tabIndex = 0 }) => {
  return React__default.default.createElement(
    components_forms_FormLabel_FormLabel.FormLabel,
    { isDisabled, isErrored, isRequired, isSelected: checked, justifyContent: "stretch" },
    React__default.default.createElement(
      "span",
      { className: styles.labeledBooleanInputRoot, "data-errored": isErrored ? "" : void 0, "data-zds": true },
      React__default.default.createElement(components_forms_BooleanInput_BooleanInput.BooleanInput, { "aria-label": ariaLabel, checked, disabled: isDisabled, id, isErrored, name, onChange, tabIndex, type, value }),
      children
    )
  );
};

exports.LabeledBooleanInput = LabeledBooleanInput;
//# sourceMappingURL=LabeledBooleanInput.cjs.js.map
